import { fieldRequiredInformation, fieldRequiredItems, fieldRomaji } from './../../services/fieldRequired';
import { regexIsRomanji, regexJapanese, regexName, regexPhone, validateEmail } from './../../services/ruleValidate';
import { ListChannel as ListChannelConst } from './../../constants/setting_channel';
import Storage from './../../services/Storage';

export const handleApiOrder = (dataOrder, informationFill, itemsFill, state, orderRes) => {
    let listCountries = Storage.get('countries')
    let countriesCode = []
    let index = state.error.indexOf('email')
    state.error = []

    // information
    if (informationFill.email) {
        if (!validateEmail(informationFill.email) || !regexIsRomanji(informationFill.email)) {
            if (state.error.indexOf('email') === -1) {
                state.error.push('email')
            }
            state.classes.email = 'error'
        } else {
            if (index !== -1) {
                state.error.splice(index, 1)
            }
            state.classes.email = ''
        }
    } else {
        if (index !== -1) {
            state.error.splice(index, 1)
        }
        state.classes.email = ''
    }

    for (let i = 0; i < fieldRequiredInformation.length; i++) {
        if (!informationFill[fieldRequiredInformation[i]]) {
            state.classes[fieldRequiredInformation[i]] = 'error'
        } else {
            state.classes[fieldRequiredInformation[i]] = ''
        }

        if (fieldRequiredInformation[i] === 'name') {
            if (!informationFill[fieldRequiredInformation[i]] || regexName(informationFill[fieldRequiredInformation[i]])) {
                state.classes[fieldRequiredInformation[i]] = 'error'
            } else {
                state.classes[fieldRequiredInformation[i]] = ''
            }
        }
    }

    for (let m = 0; m < listCountries.length; m++) {
        countriesCode.push(listCountries[m]['CountryCode'])
    }

    if (!informationFill.yomigana || (regexJapanese(informationFill.yomigana) || regexName(informationFill.yomigana))) {
        state.classes.yomigana = 'error'
    } else {
        state.classes.yomigana = ''
    }

    for (let q = 0; q < fieldRomaji.length; q++) {
        if (informationFill[fieldRomaji[q]]) {
            if (fieldRomaji[q] === 'phone') {
                if (!regexPhone(informationFill[fieldRomaji[q]])) {
                    state.classes.phone = 'error'
                } else {
                    state.classes.phone = ''
                }
            } else {
                if (!regexIsRomanji(informationFill[fieldRomaji[q]])) {
                    state.classes[fieldRomaji[q]] = 'error'
                } else {
                    state.classes[fieldRomaji[q]] = ''
                }
            }
        }
    }

    // items
    for (let k = 0; k < itemsFill.length; k++) {
        if (orderRes && orderRes.restore) {
            itemsFill[k]['restore'] = true
        }

        if (orderRes && !orderRes.restore) {
            if (typeof orderRes.channelOrderItem !== 'undefined' && orderRes.channelOrderItem.indexOf(itemsFill[k]['channel_order_item']) !== -1) {
                itemsFill[k]['originAmazon'] = true
            }
        }

        for (let j = 0; j < fieldRequiredItems.length; j++) {
            if (!itemsFill[k][fieldRequiredItems[j]]) {
                if (informationFill.channel_short_name === ListChannelConst.AMAZON_JP.ShortName) {
                    itemsFill[k]['classes'][fieldRequiredItems[j]] = 'error'
                } else {
                    if (fieldRequiredItems[j] === 'channel_order_item') {
                        itemsFill[k]['classes'][fieldRequiredItems[j]] = ''
                    } else {
                        itemsFill[k]['classes'][fieldRequiredItems[j]] = 'error'
                    }
                }
                
            } else {
                itemsFill[k]['classes'][fieldRequiredItems[j]] = ''
            }
        }

        if (itemsFill[k].origin) {
            let indexOrigin = state.error.indexOf('origin' + itemsFill[k]['key'])
            if (countriesCode.indexOf(itemsFill[k].origin) !== -1) {
                if (indexOrigin !== -1) {
                    state.error.splice(indexOrigin, 1)
                }
                itemsFill[k].classes.origin = ''
            } else {
                if (indexOrigin === -1) {
                    state.error.push('origin' + itemsFill[k]['key'])
                }
                itemsFill[k].classes.origin = 'error'
            }
        }
        // check validate price
        if (itemsFill[k]['price_adjusted'] == 0) {
            itemsFill[k].classes.price_adjusted = 'error';
        }

        for (let t = 0; t < fieldRomaji.length; t++) {
            let indexField = state.error.indexOf(fieldRomaji[t] + itemsFill[k]['key'])
            if (itemsFill[k][fieldRomaji[t]]) {
                if (!regexIsRomanji(itemsFill[k][fieldRomaji[t]])) {
                    itemsFill[k]['classes'][fieldRomaji[t]] = 'error'

                    if (indexField === -1) {
                        state.error.push(fieldRomaji[t] + itemsFill[k]['key'])
                    }
                } else {
                    if (indexField !== -1) {
                        state.error.splice(indexField, 1)
                    }
                    itemsFill[k]['classes'][fieldRomaji[t]] = ''
                }
            }
        }

        let errorRowItem = state.rowItemError
        let checkErrorItem = []
        let indexErrorItem = errorRowItem.indexOf('rowItemError' + itemsFill[k]['key'])
        for (let q in itemsFill[k]['classes']) {
            if (itemsFill[k]['classes'][q]) {
                checkErrorItem.push('error')
            }
        }

        if (checkErrorItem.length >= 1) {
            if (indexErrorItem === -1) {
                errorRowItem.push('rowItemError' + itemsFill[k]['key'])
            }
        } else {
            if (indexErrorItem !== -1) {
                errorRowItem.splice(indexErrorItem, 1)
            }
        }

        state.rowItemError = errorRowItem
    }

    return {
        informationFill,
        itemsFill,
        state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/helper/index.js